import { useQuery } from '@tanstack/react-query'

import axios from '@/_lib/axiosInstance'
import { ApiResponse } from '@/_types'
import { IAnnualProgram } from '@/_types/annual-programs'

/**
 * Fetches full annual program configuration for annual-program order paths.
 *
 * @param id - Year program id.
 */
export const fetchYearProgram = async (id: number): Promise<ApiResponse<IAnnualProgram>> => {
	return axios
		.get<ApiResponse<IAnnualProgram>>(`v1/web/yearProgram/yearPrograms/${id}`)
		.then(res => res.data)
}

/**
 * React Query hook for {@link fetchYearProgram}; disabled when `id <= 0`.
 *
 * @param id - Year program id.
 */
export const useGetYearProgram = (id: number) => {
	return useQuery<ApiResponse<IAnnualProgram>>({
		queryKey: ['year-program', id],
		queryFn: () => fetchYearProgram(id),
		enabled: id > 0,
		select: data => data
	})
}
